export default function Table(theme) {
    return {
        MuiTable: {
            styleOverrides: {
                root: {
                    '&.MuiTable-root': {
                        borderCollapse: 'separate',
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: theme.radius(1)
                    }
                }
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    '& .MuiTableRow-root:last-of-type > .MuiTableCell-root': {
                        borderBottom: 'none'
                    }
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: theme.palette.secondary.shades['8p'],
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.shades['12p']
                        }
                    },
                    '&.MuiTableRow-hover:hover': {
                        backgroundColor: theme.palette.background[100]
                    },
                    variants: [
                        {
                            props: {
                                'data-stripped': true
                            },
                            style: {
                                '&:nth-of-type(even)': {
                                    backgroundColor: theme.palette.background[50],
                                    '&.MuiTableRow-hover:hover': {
                                        backgroundColor: theme.palette.background[200]
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    lineHeight: '1rem',
                    variants: [
                        {
                            props: {
                                'data-bordered': true
                            },
                            style: {
                                borderRight: `1px solid ${theme.palette.divider}`,
                                '&:last-child': {
                                    borderRight: 'none'
                                }
                            }
                        }
                    ]
                },
                head: {
                    color: theme.palette.text.primary,
                    backgroundColor: `${theme.palette.background[200]}`,
                    borderBottom: `1px solid ${theme.palette.divider}`
                },
                stickyHeader: {
                    backgroundColor: `${theme.palette.background[200]}`
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    '& > .MuiTableRow-root:first-of-type > .MuiTableCell-root:first-of-type': {
                        borderTopLeftRadius: theme.radius(1)
                    },
                    '& > .MuiTableRow-root:first-of-type > .MuiTableCell-root:last-of-type': {
                        borderTopRightRadius: theme.radius(1)
                    }
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                toolbar: {
                    height: 64
                },
                select: {
                    '&:focus': {
                        borderRadius: theme.radius(1)
                    }
                },
                selectIcon: {
                    width: 20,
                    height: 20
                }
            }
        }
    };
}
